import { api } from "./client";
import type {
  ConversationDetail,
  ConversationList,
  ConversationOut,
  ConversationStatus,
} from "@/types/api";

export async function listConversations(params: {
  page?: number;
  page_size?: number;
  status?: ConversationStatus;
} = {}): Promise<ConversationList> {
  const { data } = await api.get<ConversationList>("/conversations", { params });
  return data;
}

export async function createConversation(title: string): Promise<ConversationOut> {
  const { data } = await api.post<ConversationOut>("/conversations", { title });
  return data;
}

export async function getConversation(id: number): Promise<ConversationDetail> {
  const { data } = await api.get<ConversationDetail>(`/conversations/${id}`);
  return data;
}

export async function patchConversation(
  id: number,
  payload: { title?: string; status?: ConversationStatus }
): Promise<ConversationOut> {
  const { data } = await api.patch<ConversationOut>(`/conversations/${id}`, payload);
  return data;
}

export async function deleteConversation(id: number): Promise<void> {
  await api.delete(`/conversations/${id}`);
}

export async function confirmPRD(
  id: number
): Promise<{ document_id: number; status: ConversationStatus; confirmed_at: string }> {
  const { data } = await api.patch(`/conversations/${id}/confirm_prd`);
  return data;
}
